(function () {
    emailjs.init("JLN545bRtFF4f-3_U");
})();

function closeM1pModal() {
    document.getElementById('m1p-status-modal').classList.remove('m1p-modal-active');
}

window.onclick = function (event) {
    var modal = document.getElementById('m1p-status-modal');
    if (event.target == modal) closeM1pModal();
}

function showM1pModal(type, title, message) {
    const modalInner = document.getElementById('m1p-modal-inner');
    const iconContainer = document.getElementById('m1p-modal-icon-container');
    const titleEl = document.getElementById('m1p-modal-title');
    const msgEl = document.getElementById('m1p-modal-message');
    const modalOverlay = document.getElementById('m1p-status-modal');

    if (type === 'success') {
        modalInner.classList.remove('m1p-error-theme');
        modalInner.classList.add('m1p-success-theme');
        iconContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
    } else {
        modalInner.classList.remove('m1p-success-theme');
        modalInner.classList.add('m1p-error-theme');
        iconContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
    }

    titleEl.textContent = title;
    msgEl.textContent = message;
    modalOverlay.classList.add('m1p-modal-active');
}

document.getElementById('m1p-contact-form').addEventListener('submit', function (event) {
    event.preventDefault();

    const requiredInputs = this.querySelectorAll('input[required], textarea[required]');
    
    for (let i = 0; i < requiredInputs.length; i++) {
        const input = requiredInputs[i];
        
        if (!input.value.trim()) {

            const fieldName = input.getAttribute('placeholder') || 'Field'; 
            
            showM1pModal('error', 'Validation Error', 'Required fields cannot be empty or contain only spaces. Please check your input.');
            
            input.value = ""; 
            input.focus();
            input.classList.add('m1p-input-error'); 
            
            return; 
        }
    }

    const btn = document.getElementById('m1p-submit-button');
    const originalText = btn.textContent;
    btn.textContent = 'Sending...';
    btn.disabled = true;

    const phonePrefix = document.getElementById('ContactPhonePrefix').value;
    const phoneNumber = document.getElementById('ContactPhone').value;
    const fullPhone = phonePrefix ? (phonePrefix + " " + phoneNumber) : phoneNumber;

    const formData = {
        country: document.getElementById('ContactCountryInput').value,
        city: document.getElementById('ContactCity').value.trim(),
        province: document.getElementById('ContactProvince').value.trim(),
        zip: document.getElementById('ContactZip').value.trim(), 
        address: document.getElementById('ContactAddress').value.trim(),
        apt: document.getElementById('ContactApt').value.trim(),
        first_name: document.getElementById('ContactFormFirstName').value.trim(),
        last_name: document.getElementById('ContactFormLastName').value.trim(),
        user_name: (document.getElementById('ContactFormFirstName').value + ' ' + document.getElementById('ContactFormLastName').value).trim(),
        user_email: document.getElementById('ContactFormEmail').value.trim(),
        user_phone: fullPhone.trim(),
        sn_code: document.getElementById('ContactSN').value.trim(),
        purchase_channel: document.querySelector('input[name="purchase_channel"]:checked')?.value || '',
        order_number: document.getElementById('ContactOrderNum').value.trim(),
        shipping_warehouse: document.getElementById('ContactWarehouseInput').value
    };

    emailjs.send("service_r3lt825", "template_nuqcxlm", formData)
        .then(function (response) {
            console.log('SUCCESS!', response.status, response.text);
            showM1pModal('success', 'Success!', 'Thanks for contacting us. We will get back to you as soon as possible.');

            document.getElementById('m1p-contact-form').reset();

            document.getElementById('m1p-select-head').textContent = 'Select your country';
            document.getElementById('m1p-select-head').classList.remove('has-value');
            document.getElementById('ContactCountryInput').value = "";
            document.getElementById('ContactPhonePrefix').value = ""; 

            document.getElementById('m1p-warehouse-head').textContent = 'Select Warehouse';
            document.getElementById('m1p-warehouse-head').classList.remove('has-value');
            document.getElementById('ContactWarehouseInput').value = "";

        }, function (error) {
            console.log('FAILED...', error);
            showM1pModal('error', 'Submission Failed', 'Failed to send the message. Please try again later.');
        })
        .finally(function () {
            btn.textContent = originalText;
            btn.disabled = false;
        });
});

const countryData = {
    "Asia": ["China"],
    "North America": ["United States", "Canada"],
    "Europe": [
        "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
        "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary",
        "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands",
        "Poland", "Portugal", "Romania", "Slovakia", "Slovenia", "Spain", "Sweden",
        "United Kingdom", "Switzerland", "Norway"
    ]
};

const phoneCodes = {
    "China": "+86",
    "United States": "+1",
    "Canada": "+1",
    "Austria": "+43",
    "Belgium": "+32",
    "Bulgaria": "+359",
    "Croatia": "+385",
    "Cyprus": "+357",
    "Czech Republic": "+420",
    "Denmark": "+45",
    "Estonia": "+372",
    "Finland": "+358",
    "France": "+33",
    "Germany": "+49",
    "Greece": "+30",
    "Hungary": "+36",
    "Ireland": "+353",
    "Italy": "+39",
    "Latvia": "+371",
    "Lithuania": "+370",
    "Luxembourg": "+352",
    "Malta": "+356",
    "Netherlands": "+31",
    "Poland": "+48",
    "Portugal": "+351",
    "Romania": "+40",
    "Slovakia": "+421",
    "Slovenia": "+386",
    "Spain": "+34",
    "Sweden": "+46",
    "United Kingdom": "+44",
    "Switzerland": "+41",
    "Norway": "+47"
};

const selectHead = document.getElementById('m1p-select-head');
const selectBody = document.getElementById('m1p-select-body');
const hiddenInput = document.getElementById('ContactCountryInput');
const provinceWrapper = document.getElementById('m1p-province-wrapper');
const provinceInput = document.getElementById('ContactProvince');
const phonePrefixInput = document.getElementById('ContactPhonePrefix');

function initCustomSelect() {
    if (!selectBody) return;

    for (const [region, countries] of Object.entries(countryData)) {
        const groupLabel = document.createElement('div');
        groupLabel.className = 'm1p-select-group-label';
        groupLabel.textContent = region;
        selectBody.appendChild(groupLabel);

        countries.forEach(country => {
            const option = document.createElement('div');
            option.className = 'm1p-select-option';
            option.textContent = country;

            option.onclick = function (e) {
                e.stopPropagation();
                selectOption(country);
            };

            selectBody.appendChild(option);
        });
    }

    selectHead.onclick = function (e) {
        e.stopPropagation();
        closeWarehouseSelect();
        toggleSelect();
    };

    document.addEventListener('click', function (e) {
        const countrySelect = document.getElementById('m1p-custom-country-select');
        const warehouseSelect = document.getElementById('m1p-custom-warehouse-select');

        if (countrySelect && !countrySelect.contains(e.target)) {
            closeSelect();
        }
        if (warehouseSelect && !warehouseSelect.contains(e.target)) {
            closeWarehouseSelect();
        }
    });
}

function toggleSelect() {
    selectBody.classList.toggle('open');
    selectHead.classList.toggle('open');
}

function closeSelect() {
    if (selectBody) selectBody.classList.remove('open');
    if (selectHead) selectHead.classList.remove('open');
}

function selectOption(countryName) {
    selectHead.textContent = countryName;
    selectHead.classList.add('has-value');
    hiddenInput.value = countryName;

    if (phoneCodes[countryName]) {
        phonePrefixInput.value = phoneCodes[countryName];
    } else {
        phonePrefixInput.value = "";
    }

    checkRegionLogic(countryName);
    closeSelect();
}

function checkRegionLogic(countryName) {
    const europeCountries = countryData["Europe"];
    const asterisk = provinceWrapper.querySelector('.m1-ps');
    if (europeCountries.includes(countryName)) {
        provinceWrapper.style.display = 'flex';
        provinceInput.removeAttribute('required');
        if (asterisk) asterisk.style.display = 'none';
    } else {
        provinceWrapper.style.display = 'flex';
        provinceInput.setAttribute('required', 'required');
        if (asterisk) asterisk.style.display = 'inline';
    }
}

const warehouseData = [
    "US Warehouse",
    "European Warehouse",
    "China Warehouse (Additional shipping fees apply)"
];

const warehouseHead = document.getElementById('m1p-warehouse-head');
const warehouseBody = document.getElementById('m1p-warehouse-body');
const warehouseInput = document.getElementById('ContactWarehouseInput');

function initWarehouseSelect() {
    if (!warehouseBody) return;

    warehouseData.forEach(wh => {
        const option = document.createElement('div');
        option.className = 'm1p-select-option';
        option.textContent = wh;

        option.onclick = function (e) {
            e.stopPropagation();
            selectWarehouseOption(wh);
        };
        warehouseBody.appendChild(option);
    });

    warehouseHead.onclick = function (e) {
        e.stopPropagation();
        closeSelect();
        toggleWarehouseSelect();
    };
}

function toggleWarehouseSelect() {
    warehouseBody.classList.toggle('open');
    warehouseHead.classList.toggle('open');
}

function closeWarehouseSelect() {
    if (warehouseBody) warehouseBody.classList.remove('open');
    if (warehouseHead) warehouseHead.classList.remove('open');
}

function selectWarehouseOption(value) {
    warehouseHead.textContent = value;
    warehouseHead.classList.add('has-value');
    warehouseInput.value = value;
    closeWarehouseSelect();
}

initCustomSelect();
initWarehouseSelect();
